import React from "react";
import "./index.css";

function SpinnerLoader({ size }: { size?: string }) {
  return (
    <>
      {size ? (
        <div className="lds-ring" style={{ width: size, height: size }}>
          <>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </>
        </div>
      ) : (
        <div className="lds-ring">
          <>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </>
        </div>
      )}
    </>
  );
}

export default SpinnerLoader;
